<template>
  <div>
    <div class="banner">
      和优秀的人，做有挑战的事
    </div>
    
    <div>
      <div class="contact-us-page">
        <div class="contact-us-container">
          <div class="contact-info">
            <h2>公司信息</h2>
            <div class="info-item">
              <i class="fa fa-building"></i> 公司名称：
              <p>中科淞塔（苏州）科技有限公司</p>
            </div>
            <div class="info-item">
              <i class="fa fa-map-marker"></i> 公司地址：
              <p>中国（江苏）自由贸易试验区苏州片区苏州工业园区金鸡湖大道88号人工智能产业园D1-063单元</p>
            </div>
            <div class="info-item">
              <i class="fa fa-phone"></i> 联系电话：
              <p>+86 188 8888 8888</p>
            </div>
            <div class="info-item">
              <i class="fa fa-envelope"></i> 电子邮箱：
              <p>sota@zksota.com</p>
            </div>
          </div>
          
          <div class="contact-form">
            <h1>用户充值</h1>
		
			<PayPage />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PayPage from './PayPage.vue';

export default {
  data() {
    return {
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  components:{
      PayPage,
  },
  methods: {
    async submitForm() {
      try {
        // 将表单数据发送到服务器
        const response = await axios.post(
          this.$serverUrl + '/api/addUserFeedback', // 拼接服务器地址和端点
          this.form // 发送的表单数据
        );
        
        // 处理成功的响应
        console.log('Form submitted successfully:', response.data);

        // 提示用户提交成功或清空表单
        this.$message.success('提交成功，感谢您的信任与支持！');
        this.resetForm();
      } catch (error) {
        // 处理错误响应
        console.error('Form submission error:', error);

        // 提示用户提交失败
		this.$message.error(`提交失败，请稍后再试。`);
      }
    },
    resetForm() {
      // 重置表单数据
      this.form = {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      };
    }
  }
};
</script>


<style scoped>
	.banner {
  height: 200px;
  line-height: 200px;
  color: #fff;
  background-image: url("../../assets/images/connect.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: 1em;
  margin-bottom: 50px;
}
	
.contact-us-page {
  padding: 20px;
}

.contact-us-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 30px;
  width: 70%;
  margin: auto;
}

.contact-info {
  /* max-width: 300px; */
  width: 20%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-info h2 {
  margin-bottom: 15px;
}

.contact-info p {
  margin: 5px 0;
}

.social-media {
  margin-top: 15px;
}

.social-media a {
  margin: 0 10px;
}

.social-media img {
  width: 30px;
  height: 30px;
  transition: transform 0.3s;
}

.social-media img:hover {
  transform: scale(1.2);
}

.contact-form {
  /* max-width: 600px; */
  width: 70%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-form h1 {
  text-align: center;
  margin-bottom: 20px;
}

.contact-form form div {
  margin-bottom: 15px;
}

.contact-form form label {
  display: block;
  margin-bottom: 5px;
}

.contact-form form input,
.contact-form form textarea {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.contact-form form textarea {
  height: 100px;
  resize: none;
}

.contact-form form button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.3s;
}

.contact-form form button:hover {
  background-color: #0056b3;
}


.contact-info {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-info h2 {
  font-size: 2em;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.info-item {
  /* display: flex; */
  align-items: center;
  margin-bottom: 25px;
  color: #555;
}

.info-item i {
  margin-right: 10px;
  color: #007bff;
  font-size: 1.2em;
}

.info-item p {
  margin: 0;
  margin-top: 5px;
  font-size: 1.1em;
  line-height: 2;
}

@media (max-width: 768px) {
  .contact-info {
    padding: 15px;
  }
  
  .contact-info h2 {
    font-size: 1.5em;
  }

  .info-item p {
    font-size: 0.9em;
  }
}

</style>
